import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Input,
  Label,
  Row,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import BreadCrumb from "../../components/common/breadCrumb";
import DeleteModal from "../../components/common/deleteModal";
import { toast } from "react-toastify";
import Flatpickr from "react-flatpickr";
import {
  digitRegex,
  emailRegex,
  InputPlaceHolder,
  passwordRegex,
  phoneRegex,
  SelectPlaceHolder,
  validationMessages,
} from "../../utils/helpers/validationMasseges";
import {
  addEmployee,
  countOfEmployee,
  activeDeActiveEmployee,
  editEmployee,
  filterOfEmployee,
  listOfEmployee,
  deleteEmployee,
  employeeLeaveCount,
} from "../../api/employeeApi";
import userDummyImg from "../../assets/image/auth-one-bg.jpg";
import * as Yup from "yup";
import { useFormik } from "formik";
import Widgets from "../dashboard/widgets";
import Loader from "../../components/common/loader";
import { getId, getRole } from "../../utils/helpers/custom";
import { listOfAssigningCourse, listOfData } from "../../api/commonApi";
import { designationDetails, ResponseStatusEnum, roleDetails, statusDetails } from "../../utils/helpers/enums";
import { assignCourse, listTopics } from "../../api/itpApi";
import { dashboardMultiCard } from "../../api/dashboardApi";
import { baseImageURL } from "../../api/baseURL";
import ApproveRejectModal from "../../components/common/approveRejectModal";
import { changeSenior } from "../../api/employeeApi";
import { employeeProfile } from "../../api/profileApi";
import { conditionallyRequired } from "../../utils/helpers/formUtils";
import Toggle from "./toggle";
import { listOfProject } from "../../api/itpProject";
import { listofjunior } from "../../api/tasksheetApi";
import {
  checkStatusCodeSuccess,
  CommonLabel,
  dateFormat,
  ErrorImage,
  HandleResponse,
  onError,
  RequiredSign,
  Roles,
} from "../../utils/helpers/common";
import {
  EmployeeLabels,
} from "../../common/constant/Employee";
import BaseInput from "../../components/BaseComponents/BaseInput";
import BaseButton from "../../components/BaseComponents/BaseButton";
import BaseModal from "../../components/BaseComponents/BaseModal";
import {
  BaseSelect,
  MultiSelect,
} from "../../components/BaseComponents/BaseSelect";
import { Tooltip as ReactTooltip } from "react-tooltip";

const Employee = () => {
  document.title = EmployeeLabels.Employee;
  const [deleteModal, setDeleteModal] = useState(false);
  const [modalTodo, setModalTodo] = useState(false);
  const [modalTodoCourse, setModalTodoCourse] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [modalLoader, setModalLoader] = useState(false);
  const [employeeData, setEmployeeData] = useState([]);
  const [employeeOption, setEmployeeOption] = useState([]);
  const [employeeDetails, setEmployeeDetails] = useState([]);
  const [employeeResId, setEmployeeResId] = useState([]);
  const [employeePerData, setEmployeePerData] = useState([]);
  const [designation, setdesignation] = useState([]);
  const [topic, setTopic] = useState([]);
  const [selectedMulti, setSelectedMulti] = useState([]);
  const [selectedMultiProject, setSelectedMultiProject] = useState([]);
  const [assignCourseData, setAssignCourseData] = useState([]);
  const [dashboardCard, setdashboardMultiCard] = useState();
  const [passwordShow, setPasswordShow] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [gridList, setGridList] = useState("grid-view-filter");
  const [modalReallocation, setModalReallocation] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [selectedCourse2, setSelectedCourse2] = useState("");
  const [editEmplyeeData, setEditEmployeeData] = useState();
  const [editId, setEditId] = useState();
  const [itpProject, setItpProject] = useState([]);
  const [responseMessage, setResponseMessage] = useState([]);
  const [employeeLeave, setEmployeeLeave] = useState([]);
  const [modalLeave, setModalLeave] = useState(false);
  const [employeeId, setEmployeeId] = useState(null);
  const userIdCookie = getId();
  const userRoleCookie = getRole();

  const employee = [
    {
      id: 1,
      cardColor: "primary",
      label: EmployeeLabels.TotalEmployee,
      badgeClass: "success",
      counter: dashboardCard?.totalUserData,
      bgcolor: "success",
      icon: "ri-account-box-fill",
      decimals: 0,
      prefix: "",
      suffix: "",
    },
    {
      id: 2,
      cardColor: "primary",
      label: EmployeeLabels.ActiveEmployee,
      badge: "ri-arrow-right-up-line",
      badgeClass: "success",
      percentage: dashboardCard?.activeEmployeeOfCurrentMonth,
      counter: dashboardCard?.countActiveUserData,
      bgcolor: "success",
      icon: "ri-team-fill",
      decimals: 0,
      prefix: "",
      suffix: "",
    },
    {
      id: 3,
      cardColor: "primary",
      label: EmployeeLabels.InActiveEmployee,
      badgeClass: "success",
      counter: dashboardCard?.countInactiveUserData,
      bgcolor: "success",
      icon: "ri-team-fill",
      decimals: 0,
      prefix: "",
      suffix: "",
    },
    {
      id: 4,
      cardColor: "primary",
      label: EmployeeLabels.DeletedEmployee,
      badgeClass: "success",
      counter: dashboardCard?.countDeletedUserData,
      bgcolor: "success",
      icon: "ri-team-fill",
      decimals: 0,
      prefix: "",
      suffix: "",
    },
  ];

  function handleMulti(selectedMulti) {
    setSelectedMulti(selectedMulti || []);
  }

  function handleMultiProject(selectedMulti) {
    setSelectedMultiProject(selectedMulti);
  }

  const handleEditClick = (resp) => {
    setEditLoading(true);
    setIsEdit(true);
    setModal(true);
    setEditId(resp?.id);
    employeeProfile(resp?.id)
      .then((res) => {
        if (checkStatusCodeSuccess(res?.data?.statusCode)) {
          setEditEmployeeData(res?.data?.data);
        }
      })
      .catch((err) => {
        return err;
      })
      .finally(() => {
        setEditLoading(false);
      });
  };

  const handleTodoClicks = () => {
    setModalTodo(!modalTodo);
    setIsEdit(false);
    toggle();
  };

  const handleTodoClicksCourse = () => {
    setModalTodoCourse(!modalTodoCourse);
    toggleCourse();
  };

  const [isEdit, setIsEdit] = useState(false);
  const [modal, setModal] = useState(false);
  const [modalCourse, setModalCourse] = useState(false);
  const [checkbox, setCheckBox] = useState(false);
  const [selectedId, setSelectedId] = useState();
  const [filterEmployeeData, setFilterEmployeeData] = useState();

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      validation.resetForm();
      setEditEmployeeData("");
    } else {
      setModal(true);
    }
  }, [modal]);

  const toggleCourse = useCallback(() => {
    if (modalCourse) {
      setModalCourse(false);
      setSelectedMulti("");
    } else {
      setModalCourse(true);
    }
  }, [modalCourse]);

  const handleDeleteOrder = () => {
    setModalLoader(true);
    deleteEmployee(employeePerData?.id, {
      isDeleted: true,
    })
      .then((response) => {
        if (checkStatusCodeSuccess(response?.data?.statusCode)) {
          toast.success(response?.data?.message);
        }
        fetchData();
        setDeleteModal(false);
      })
      .catch((err) => {
        toast.error(err?.data?.message);
        return err;
      })
      .finally(() => {
        setModalLoader(false);
      });
  };

  const fetchData = () => {
    setLoading(true);
    listOfEmployee({
      role: [Roles.Employee, Roles.HR, Roles.BDE, Roles.Admin],
      isDeleted: false,
    })
      .then((resp) => {
        if (checkStatusCodeSuccess(resp?.data?.statusCode)) {
          setEmployeeData(resp?.data?.data);
          setEmployeeOption(
            resp?.data?.data?.map((item) => ({
              value: item?.id,
              label: `${item?.firstName}${" "}${item.lastName}`,
            }))
          );
        }
      })
      .catch((err) => {
        return err;
      })
      .finally(() => {});

    Promise.all([
      dashboardMultiCard()
        .then((response) => {
          setdashboardMultiCard(response?.data?.data);
        })
        .catch((err) => err)
        .finally(() => {
          setLoading(false);
        }),

      countOfEmployee({
        modelName: "authUserModel",
        condition: {
          isDeleted: 0,
          role: [Roles.Employee],
        },
      })
        .then((resp) => {})
        .catch((err) => {
          return err;
        })
        .finally(() => {}),

      countOfEmployee({
        modelName: "authUserModel",
        condition: {
          isDeleted: 1,
        },
      })
        .then((resp) => {})
        .catch((err) => {
          return err;
        })
        .finally(() => {}),

      listOfData({
        modelName: "technologyModel",
        selectionCriteria: ["id", "techName"],
      })
        .then((resp) => {
          if (checkStatusCodeSuccess(resp?.statusCode)) {
            setdesignation(
              resp?.data?.map((item) => ({
                value: item?.id,
                label: item?.techName,
              }))
            );
          }
        })
        .catch((err) => {
          return err;
        })
        .finally(() => {}),

      listTopics({})
        .then((resp) => {
          if (checkStatusCodeSuccess(resp?.data?.statusCode)) {
            setTopic(
              resp?.data?.data?.map((res) => {
                return {
                  value: `${res?.id}`,
                  label: `${res?.courseName}`,
                };
              })
            );
          }
        })
        .catch((err) => {
          return err;
        })
        .finally(() => {
          setLoading(false);
        }),

      listOfProject({})
        .then((resp) => {
          if (checkStatusCodeSuccess(resp?.statusCode)) {
            setItpProject(
              resp?.data?.map((res) => {
                return {
                  value: `${res?.id}`,
                  label: `${res?.projectName}`,
                };
              })
            );
          }
        })
        .catch((err) => {
          return err;
        })
        .finally(() => {
          setLoading(false);
        }),

      listofjunior()
        .then((resp) => {
          if (checkStatusCodeSuccess(resp?.data?.statusCode)) {
            setEmployeeDetails(
              resp?.data?.data?.map((status) => ({
                value: status?.developerName,
                label: status?.developerName,
              }))
            );
          }
        })
        .catch((err) => {
          return err;
        })
        .finally(() => {
          setLoading(false);
        }),
    ]);
  };

  const handleReallocationClick = () => {
    setModalLoader(true);
    const payload = {
      assignerId: selectedCourse,
      assigneeId: selectedCourse2,
    };
    changeSenior(payload)
      .then((response) => {
        if (checkStatusCodeSuccess(response?.data?.statusCode)) {
          toast.success(response?.data?.message);
        }
        setModalReallocation(false);
      })
      .catch((error) => {})
      .finally(() => {
        setModalLoader(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const list = document.querySelectorAll(".team-list");
    const buttonGroups = document.querySelectorAll(".filter-button");
    for (const element of buttonGroups) {
      element.addEventListener("click", onButtonGroupClick);
    }

    function onButtonGroupClick(event) {
      if (
        event?.target?.id === "list-view-button" ||
        event?.target?.parentElement?.id === "list-view-button"
      ) {
        document.getElementById("list-view-button").classList.add("active");
        document.getElementById("grid-view-button").classList.remove("active");
        list?.forEach(function (el) {
          el?.classList.add("list-view-filter");
          el?.classList.remove("grid-view-filter");
        });
      } else {
        document.getElementById("grid-view-button").classList.add("active");
        document.getElementById("list-view-button").classList.remove("active");
        list?.forEach(function (el) {
          el?.classList.remove("list-view-filter");
          el?.classList.add("grid-view-filter");
        });
      }
    }
  }, []);

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      technologyId:
        checkbox === true ? null : editEmplyeeData?.technology?.id || "",
      firstName: editEmplyeeData?.firstName || "",
      remainLeave: editEmplyeeData?.reamingLeave || "",
      lastName: editEmplyeeData?.lastName || "",
      email: editEmplyeeData?.email || "",
      assignTo: editEmplyeeData?.assignTo || "",
      password: editEmplyeeData?.password || "",
      phoneNo: editEmplyeeData?.phoneNo || "",
      dateOfJoin: editEmplyeeData?.dateOfJoin || "",
      hrCheck: editEmplyeeData?.role === Roles.HR,
      bdeCheck: editEmplyeeData?.role === Roles.BDE,
    },
    validationSchema: Yup.object({
      lastName: Yup.string().required(validationMessages.required(EmployeeLabels.LastName)),
      firstName: Yup.string().required(validationMessages.required(EmployeeLabels.FirstName)),
      remainLeave: Yup.string().required(
        validationMessages.required(EmployeeLabels.RemainingLeave)
      ),
      email: Yup.string()
        .required(validationMessages.required(EmployeeLabels.OfficialEmailId))
        .matches(emailRegex, validationMessages.format(EmployeeLabels.Email)),
      assignTo: conditionallyRequired(
        isEdit,
        validationMessages.required(EmployeeLabels.AssignTo)
      ),
      password: conditionallyRequired(
        isEdit,
        validationMessages.required(EmployeeLabels.Password)
      ).
      matches(
        passwordRegex,
        validationMessages.passwordComplexity(EmployeeLabels.Password)
      ),
      phoneNo: Yup.string()
        .required(validationMessages.required(EmployeeLabels.PhoneNo))
        .matches(
          phoneRegex,
          validationMessages.contactLength(EmployeeLabels.PhoneNo, 10)
        ),
      dateOfJoin: Yup.string().required(
        validationMessages.required(EmployeeLabels.DateOfJoining)
      ),
      technologyId: Yup.string().when(["hrcheck", "bdeCheck"], {
        is: (hrCheck, bdeCheck) => !hrCheck && !bdeCheck,
        then: Yup.string().required(validationMessages.required(EmployeeLabels.Technology)),
        otherwise: Yup.string(),
      }),
    }),
    onSubmit: (values) => {
      setModalLoader(true);
      if (isEdit) {
        editEmployee(editId, {
          user: {
            technologyId:
              values.hrcheck === true || values.bdeCheck === true
                ? null
                : values.technologyId,
            firstName: values.firstName,
            lastName: values.lastName,
            email: values.email,
            role:
              values.hrcheck === true
                ? Roles.HR
                : values.bdeCheck === true
                ? Roles.BDE
                : Roles.Employee,
            phoneNo: `${values.phoneNo}`,
            dateOfJoin: values.dateOfJoin,
          },
          leave: {
            remainLeave: values.remainLeave,
          },
        })
          .then((response) => {
            if (checkStatusCodeSuccess(response?.data?.statusCode)) {
              toast.success(response?.data?.message);
              setEmployeeResId(response?.data?.data);
              fetchData();
              toggle();
            } else {
              toast.error(response?.data?.message);
            }
          })
          .catch((err) => {
            toast.error(err?.data?.message);
            return err;
          })
          .finally(() => {
            setModalLoader(false);
          });
        validation.resetForm();
      } else {
        addEmployee({
          userId: userIdCookie,
          addedBy: `${userRoleCookie}`,
          reportTo: values.assignTo,
          technologyId:
            values.hrcheck === true || values.bdeCheck === true
              ? null
              : values.technologyId,
          firstName: values.firstName,
          lastName: values.lastName,
          email: values.email,
          password: values.password,
          role:
            values.hrcheck === true
              ? Roles.HR
              : values.bdeCheck === true
              ? Roles.BDE
              : Roles.Employee,
          phoneNo: `${values.phoneNo}`,
          dateOfJoin: values.dateOfJoin,
          remainLeave: values.remainLeave,
        })
          .then((response) => {
            if (checkStatusCodeSuccess(response?.data?.statusCode)) {
              toast.success(response?.data?.message);
              setEmployeeResId(response?.data?.data);
              setAssignCourseData(values);
              fetchData();
              toggle();
              if (values?.hrcheck === false) {
                handleTodoClicksCourse();
              }
            } else {
              toast.error(response?.data?.message);
            }
          })
          .catch((err) => {
            toast.error(err?.data?.message);
            return err;
          })
          .finally(() => {
            setModalLoader(false);
          });
        validation.resetForm();
      }
    },
  });
  const assignParticularCourse = (data) => {
    setModalLoader(true);
    listOfAssigningCourse({ assignTo: data?.id, isDeleted: false })
      .then((res) => {
        if (checkStatusCodeSuccess(res?.data?.statusCode)) {
          setSelectedMulti(
            res?.data?.data?.map((data, key) => {
              return {
                value: data?.course?.id,
                label: data?.course?.courseName,
              };
            })
          );
        }
      })
      .catch((err) => {
        return err;
      })
      .finally(() => {
        setModalLoader(false);
      });
    setAssignCourseData(data);
    setEmployeeResId({ id: data?.id });
  };

  const onsubmitCourse = (e) => {
    setModalLoader(true);
    assignCourse({
      courseId:
        selectedMulti?.length > 0
          ? selectedMulti?.map((res) => parseInt(res?.value))
          : null,
      itpProjectId: selectedMultiProject?.map((res) => parseInt(res?.value)),
      assignTo: parseInt(employeeResId?.id),
      assigner: parseInt(userIdCookie),
    })
      .then((response) => {
        const responseBody = response?.data;
        if (checkStatusCodeSuccess(responseBody?.statusCode)) {
          toast.success(response?.data?.message);
          fetchData();
          toggleCourse();
        } else {
          toast.error(responseBody?.message);
          toggleCourse();
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.data?.message);
        toggleCourse();
        return err;
      })
      .finally(() => {
        setModalLoader(false);
        setSelectedMulti("");
      });
  };

  const openModal = () => {
    setModalReallocation(true);
  };

  const handleHrCheckChange = () => {
    validation.setFieldValue("hrCheck", !validation.values.hrCheck);
    validation.setFieldValue("bdeCheck", false);
  };

  const handleBdeCheckChange = () => {
    validation.setFieldValue("bdeCheck", !validation.values.bdeCheck);
    validation.setFieldValue("hrCheck", false);
  };

  const validationFilter = useFormik({
    enableReinitialize: true,

    initialValues: {
      employeeName: "",
      employeeDesignation: "",
      employeeStatus: "",
      role: "",
    },
    validationSchema: Yup.object({
      employeeName: Yup.string(
        validationMessages.text(EmployeeLabels.EmployeeName)
      ),
      employeeDesignation: Yup.string(
        validationMessages.text(EmployeeLabels.EmployeeDesignation)
      ),
      employeeStatus: Yup.string(
        validationMessages.text(EmployeeLabels.EmployeeStatus)
      ),
      role: Yup.string(validationMessages.text(EmployeeLabels.Role)),
    }),
    onSubmit: (value) => {
      setLoading(true);
      let payload = {
        employeeName: value.employeeName,
        employeeDesignation: value.employeeDesignation,
        status: value.employeeStatus,
        role: value.role,
      };
      filterOfEmployee(payload)
        .then((res) => {
          if (checkStatusCodeSuccess(res?.data?.statusCode)) {
            setFilterEmployeeData(res?.data?.data);
            setLoading(false);
          } else {
            setFilterEmployeeData([]);
          }
        })
        .catch((err) => {
          setFilterEmployeeData([]);
          return err;
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });

  let dataList = filterEmployeeData ?? employeeData;

  const [toggleStatuses, setToggleStatuses] = useState([]);

  const handleToggle = () => {
    const initialToggles = dataList?.map((item) => item?.isActive === true);
    setToggleStatuses(initialToggles);
  };
  useEffect(() => {
    if (dataList && dataList?.length > 0) {
      handleToggle();
    }
  }, [dataList]);

  const handleApprove = (row) => {
    setSelectedRow({ ...row, action: EmployeeLabels.InactiveUser });

    if (!row.isActive === false) {
      setResponseMessage(EmployeeLabels.InactiveConfirmation);
    } else {
      setResponseMessage(EmployeeLabels.ActiveConfirmation);
    }

    setUpdateModal(true);
    const updatedRow = { ...row, isActive: !row.isActive };
    setSelectedId(updatedRow);

  };

  const handleApproveSupport = () => {
    setModalLoader(true);
    const isDeletedValue = selectedRow.isActive ? false : true;

    activeDeActiveEmployee(selectedId?.id, { isActive: isDeletedValue })
      .then((response) => {
        setUpdateModal(false);
        if (response.data.statusCode === ResponseStatusEnum.SUCCESS) {
          toast.success(response?.data?.message);
          setUpdateModal(false);
          if (userRoleCookie === Roles.Admin) {
            listOfEmployee({
              role: [Roles.Employee, Roles.HR, Roles.BDE],
              isDeleted: false,
            })
              .then((resp) => {
                if (checkStatusCodeSuccess(resp?.data?.statusCode)) {
                  setEmployeeData(resp?.data?.data);
                }
              })
              .catch((err) => {
                return err;
              })
              .finally(() => {});
          } else {
            listOfEmployee({
              role: [Roles.Employee, Roles.BDE],
              isDeleted: false,
            })
              .then((resp) => {
                if (checkStatusCodeSuccess(resp?.data?.statusCode)) {
                  setEmployeeData(resp?.data?.data);
                }
              })
              .catch((err) => {
                return err;
              })
              .finally(() => {});
          }
        } else {
          toast.error(response?.data?.message);
        }
      })
      .catch((err) => {
        return err;
      })
      .finally(() => {
        setModalLoader(false);
      });
  };

  const handleToggleChange = (index, res) => {
    const newToggles = [...toggleStatuses];
    newToggles[index] = !newToggles[index];
    setToggleStatuses(newToggles);
    handleApprove(res);
  };

  useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);

  const assignToData = Array.isArray(employeeData)
    ? employeeData?.map((status) => ({
        value: status?.id,
        label: `${status?.firstName} ${status?.lastName}`,
      }))
    : null;

  assignToData.unshift({
    value: 1,
    label: Roles.Admin,
  });

  const handleEmployeeLeave = (id) => {
    setModalLoader(true);
    employeeLeaveCount(id)
      .then((response) => {
        if (checkStatusCodeSuccess(response?.data?.statusCode)) {
          setEmployeeLeave(response?.data?.data);
        }
      })
      .catch((err) => {
        return err;
      })
      .finally(() => {
        setModalLoader(false);
      });
  }
  const handleLeaveModal = (id) => {    
    setModalLeave(!modalLeave);
    setEmployeeId(id);
    handleEmployeeLeave(id);
  }
  const InfoRow = ({ label, value, iconClass }) => {
    return (
      <div className="d-flex align-items-center gap-2 p-2 border rounded bg-light mb-2">
        <i className={`${iconClass} text-primary mt-1`} />
        <h5 className="mb-0">{label}:</h5>
        <b className="font-weight-bold">{value ?? HandleResponse.NoData}</b>
      </div>
    );
  };

  return (
    <React.Fragment>
      <ApproveRejectModal
        show={updateModal}
        onDeleteClick={() => handleApproveSupport()}
        onCloseClick={() => {
          handleToggle();
          setUpdateModal(false);
        }}
        loader={modalLoader}
        message={responseMessage}
      />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteOrder}
        onCloseClick={() => setDeleteModal(false)}
        loader={modalLoader}
      />
      <div className="page-content">
        {loading === false ? (
          <Container fluid>
            <BreadCrumb title={EmployeeLabels.Employee} pageTitle="HRMS" />
            <Row className="mb-2">
              <div className="col-sm order-3 order-sm-2 mt-3 mt-sm-0">
                <h5 className="fw-semibold mt-2">{EmployeeLabels.Employees}</h5>
              </div>

              <div className="col-auto order-2 order-sm-3 ms-auto">
                <div className="hstack gap-2">
                  <BaseButton
                    color="primary"
                    type="button"
                    onClick={() => handleTodoClicks()}
                  >
                    <i className="ri-add-line mt-2" />
                    {EmployeeLabels.Employee}
                  </BaseButton>
                </div>
              </div>

              <div className="col-auto order-2 order-sm-3 ms-auto">
                <div className="hstack gap-2">
                  <BaseButton color="primary" type="button" onClick={openModal}>
                    <i className="ri-add-line mt-2" />
                    {EmployeeLabels.ReAllocation}
                  </BaseButton>
                </div>
              </div>
            </Row>
            <Row>
              <Widgets data={employee} />
            </Row>
            <Card>
              <CardBody>
                <Row className="g-2">
                  <Col xl={12}>
                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <Row>
                        <Col>
                          <div className="p-2">
                            <BaseSelect
                              name="employeeName"
                              options={employeeDetails}
                              placeholder={
                                EmployeeLabels.EmployeeName
                              }
                              value={validationFilter.values.employeeName}
                              handleChange={(field, value) => {
                                validationFilter.setFieldValue(field, value);
                              }}
                              handleBlur={validationFilter.handleBlur}
                              error={validationFilter.errors.employeeName}
                              touched={validationFilter.touched.employeeName}
                              required
                            />
                          </div>
                        </Col>
                        <Col>
                          <div className="p-2">
                            <BaseSelect
                              name="employeeDesignation"
                              options={designationDetails}
                              placeholder={
                                EmployeeLabels.EmployeeDesignation
                              }
                              value={
                                validationFilter.values.employeeDesignation
                              }
                              handleChange={(field, value) => {
                                validationFilter.setFieldValue(field, value);
                              }}
                              handleBlur={validationFilter.handleBlur}
                              error={
                                validationFilter.errors.employeeDesignation
                              }
                              touched={
                                validationFilter.touched.employeeDesignation
                              }
                              required
                            />
                          </div>
                        </Col>
                        <Col>
                          <div className="p-2">
                            <BaseSelect
                              name="employeeStatus"
                              options={statusDetails}
                              placeholder={
                                EmployeeLabels.EmployeeStatus
                              }
                              value={validationFilter.values.employeeStatus}
                              handleChange={(field, value) => {
                                validationFilter.setFieldValue(field, value);
                              }}
                              handleBlur={validationFilter.handleBlur}
                              error={validationFilter.errors.employeeStatus}
                              touched={validationFilter.touched.employeeStatus}
                              required
                            />
                          </div>
                        </Col>
                        <Col>
                          <div className="p-2">
                            <BaseSelect
                              name="role"
                              options={roleDetails}
                              placeholder={
                                EmployeeLabels.Role
                              }
                              value={
                                selectedStatus || validationFilter?.values?.role
                              }
                              handleChange={(field, value) => {
                                validationFilter.setFieldValue(field, value);
                              }}
                              handleBlur={validationFilter.handleBlur}
                              error={validationFilter.errors.role}
                              touched={validationFilter.touched.role}
                              required
                            />
                          </div>
                        </Col>
                        <Col>
                          <div className="m-2">
                            <BaseButton
                              color="primary"
                              type="submit"
                              onClick={validationFilter.handleSubmit}
                              label={CommonLabel.Search}
                              loader={loading}
                              className="w-100"
                            />
                          </div>
                        </Col>
                        <Col>
                          <div className="list-grid-nav hstack gap-1 mt-2">
                            <BaseButton
                              color="info"
                              type="button"
                              onClick={() => {
                                setGridList("grid-view-filter");
                              }}
                              className={`btn btn-soft-info nav-link btn-icon fs-15 ${
                                gridList === "grid-view-filter" && "active"
                              } filter-button`}
                            >
                              <i className="ri-grid-fill"></i>
                            </BaseButton>
                            <BaseButton
                              color="info"
                              type="button"
                              onClick={() => {
                                setGridList("list-view-filter");
                              }}
                              className={`btn btn-soft-info nav-link  btn-icon fs-15 ${
                                gridList === "list-view-filter" && "active"
                              } filter-button`}
                            >
                              <i className="ri-list-unordered"></i>
                            </BaseButton>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <Col lg={12}>
              <Row className={`team-list ${gridList}`}>
                {dataList?.length > 0 ? (
                  dataList?.map((resp, index) => {
                    return (
                      <Col key={resp?.id}>
                        <Card className="team-box">
                          <div className="team-cover">
                            <img
                              src={`${baseImageURL}${resp?.userDetails?.profileImage}`}
                              alt=""
                              onError={(e) => onError(e, true)}
                              className="img-fluid"
                            />
                          </div>
                          <CardBody className="p-4">
                            <Row className="align-items-center team-row">
                              <Col className="col mt-2">
                                <div className="team-profile-img">
                                  <div className="avatar-lg img-thumbnail rounded-circle flex-shrink-0">
                                    <img
                                      src={`${baseImageURL}${resp?.userDetails?.profileImage}`}
                                      alt=""
                                      onError={(e) => onError(e, true)}
                                      className="img-fluid d-block rounded-circle h-100 w-100"
                                    />
                                  </div>
                                  <div className="team-content d-flex flex-column employee-title">
                                    <div className="d-flex" to="#">
                                      <h5 className="fs-16 mx-2">
                                        {resp?.firstName}
                                      </h5>
                                      <h5 className="fs-16">
                                        {resp?.lastName}
                                      </h5>
                                    </div>
                                    <p className="text-muted mb-0">
                                      {resp?.role === Roles.BDE ||
                                      resp?.role === Roles.HR
                                        ? resp?.role
                                        : resp?.role +
                                          " " +
                                          resp?.technology?.techName}
                                    </p>
                                    <p className="text-muted mb-0">
                                      {dateFormat(resp?.dateOfJoin)}
                                    </p>
                                  </div>
                                  <div className="">
                                    <Toggle
                                      toggle={toggleStatuses[index]}
                                      handleToggleChange={() => {
                                        handleToggleChange(index, resp);
                                      }}
                                    />
                                  </div>
                                </div>
                              </Col>
                              <Col className="col">
                                <div className="d-flex">
                                  <Link
                                    to={`/employee-profile/${resp?.id}`}
                                    className="btn btn-light view-btn custom_css_align_item_center"
                                  >
                                    {EmployeeLabels.ViewProfile}
                                  </Link>
                                  <BaseButton
                                    color="light"
                                    type="button"
                                    onClick={() => {
                                      setModalCourse(true);
                                      assignParticularCourse(resp);
                                    }}
                                    label={EmployeeLabels.AssignITP}
                                    loader={loading}
                                    className="view-btn mx-2"
                                  />
                                  <BaseButton
                                    color="light"
                                    type="button"
                                    onClick={() => {
                                      handleLeaveModal(resp?.id);
                                    }}
                                    loader={loading}
                                    className="view-btn mx-2"
                                    
                                  >
                                    <i className="ri-draft-line leave-icon" id={`leave-${resp?.id}`}></i>
                                  </BaseButton>
                                  <ReactTooltip
                                    place="bottom"
                                    variant="info"
                                    className="tooltip-important"
                                    content={EmployeeLabels.EmployeeLeave}
                                    anchorId={`leave-${resp?.id}`}
                                  />
                                  <div>
                                    <UncontrolledDropdown
                                      direction="start"
                                      className="btn btn-light view-btn padding-zero py-2"
                                    >
                                      <DropdownToggle
                                        tag="a"
                                        id="dropdownMenuLink2"
                                        role="button"
                                      >
                                        <i className="ri-more-fill fs-22"></i>
                                      </DropdownToggle>
                                      <DropdownMenu>
                                        <DropdownItem
                                          className="dropdown-item remove-list"
                                          onClick={() => {
                                            handleEditClick(resp);
                                          }}
                                        >
                                          <i className="ri-pencil-line me-2 align-bottom text-muted"></i>
                                          {CommonLabel.Update}
                                        </DropdownItem>
                                        <DropdownItem
                                          className="dropdown-item remove-list"
                                          onClick={() => {
                                            setDeleteModal(true);
                                            setEmployeePerData(resp);
                                          }}
                                        >
                                          <i className="ri-delete-bin-5-line me-2 align-bottom text-muted"></i>
                                          {CommonLabel.Delete}
                                        </DropdownItem>
                                      </DropdownMenu>
                                    </UncontrolledDropdown>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>
                    );
                  })
                ) : (
                  <div className="card py-4 mt-4 text-center" id="noresult">
                    <h5 className="my-4">{HandleResponse.NoDataFound}</h5>
                  </div>
                )}
              </Row>
            </Col>
          </Container>
        ) : (
          <Loader />
        )}

        <BaseModal
          open={modal}
          title={`${
            isEdit ? CommonLabel.Update : CommonLabel.Add
          } Employee Registration`}
          closeLabel={CommonLabel.Close}
          submitLabel={isEdit ? CommonLabel.Update : CommonLabel.Register}
          closeLabelColor="ghost-success"
          submitLabelColor="primary"
          loader={modalLoader}
          toggle={() => {
            setModal(false);
            setEditEmployeeData(null);
            validation.resetForm();
          }}
          submit={() => {
            validation.handleSubmit();
          }}
        >
          <Form
            className="relative-container"
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <Row>
              {editLoading && <Loader />}
              <Col lg={12}>
                <Row>
                  <Col lg={6}>
                    <div className="mb-3">
                      <BaseInput
                        name="firstName"
                        type="text"
                        placeholder={InputPlaceHolder(EmployeeLabels.FirstName)}
                        label={EmployeeLabels.FirstName}
                        onChange={validation.handleChange}
                        handleBlur={validation.handleBlur}
                        value={validation.values.firstName}
                        touched={validation.touched.firstName}
                        error={validation.errors.firstName}
                        required
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3">
                      <BaseInput
                        name="lastName"
                        type="text"
                        placeholder={InputPlaceHolder(EmployeeLabels.LastName)}
                        label={EmployeeLabels.LastName}
                        onChange={validation.handleChange}
                        handleBlur={validation.handleBlur}
                        value={validation.values.lastName}
                        touched={validation.touched.lastName}
                        error={validation.errors.lastName}
                        required
                      />
                    </div>
                  </Col>
                  <Col lg={12}>
                    <div className="mb-3">
                      <BaseInput
                        name="email"
                        type="email"
                        placeholder={InputPlaceHolder(
                          EmployeeLabels.OfficialEmailId
                        )}
                        label={EmployeeLabels.OfficialEmailId}
                        onChange={validation.handleChange}
                        handleBlur={validation.handleBlur}
                        value={validation.values.email}
                        touched={validation.touched.email}
                        error={validation.errors.email}
                        required
                      />
                    </div>
                  </Col>
                  {!isEdit && (
                    <Col lg={6}>
                      <div className="mb-3">
                        <BaseSelect
                          name="assignTo"
                          label={EmployeeLabels.AssignTo}
                          options={assignToData}
                          placeholder={SelectPlaceHolder(
                            EmployeeLabels.AssignTo
                          )}
                          value={validation.values.assignTo}
                          handleChange={(field, value) => {
                            validation.setFieldValue(field, value);
                          }}
                          handleBlur={validation.handleBlur}
                          error={validation.errors.assignTo}
                          touched={validation.touched.assignTo}
                          required
                        />
                      </div>
                    </Col>
                  )}
                  <Col lg={6}>
                    <div className="mb-3">
                      <BaseInput
                        name="remainLeave"
                        type="number"
                        placeholder={InputPlaceHolder(
                          EmployeeLabels.RemainingLeave
                        )}
                        label={EmployeeLabels.RemainingLeave}
                        onChange={(e) => {
                          if (e.target.value <= 12) {                            
                            validation.handleChange(e)
                          }
                        }}
                        handleBlur={validation.handleBlur}
                        value={validation.values.remainLeave}
                        touched={validation.touched.remainLeave}
                        error={validation.errors.remainLeave}
                        required
                      />
                    </div>
                  </Col>
                  {!isEdit && (
                    <Col lg={6}>
                      <div className="mb-3">
                        <BaseInput
                          name="password"
                          type="password"
                          placeholder={InputPlaceHolder(
                            EmployeeLabels.Password
                          )}
                          label={EmployeeLabels.Password}
                          onChange={validation.handleChange}
                          handleBlur={validation.handleBlur}
                          value={validation.values.password}
                          touched={validation.touched.password}
                          error={validation.errors.password}
                          required
                        />
                      </div>
                    </Col>
                  )}
                  <Col lg={6}>
                    <div className="mb-3">
                      <BaseInput
                        name="phoneNo"
                        type="text"
                        placeholder={InputPlaceHolder(EmployeeLabels.PhoneNo)}
                        label={EmployeeLabels.PhoneNo}
                        onChange={(e) => {
                          if (digitRegex.test(e.target.value)) {
                            validation.handleChange(e);
                          }
                        }}
                        handleBlur={validation.handleBlur}
                        value={validation.values.phoneNo}
                        touched={validation.touched.phoneNo}
                        error={validation.errors.phoneNo}
                        required
                        maxLength={10}
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3">
                      <BaseSelect
                        name="technologyId"
                        label={EmployeeLabels.Technology}
                        options={designation}
                        placeholder={SelectPlaceHolder(
                          EmployeeLabels.Technology
                        )}
                        value={validation.values.technologyId}
                        handleChange={(field, value) => {
                          validation.setFieldValue(field, value);
                        }}
                        handleBlur={validation.handleBlur}
                        error={validation.errors.technologyId}
                        touched={validation.touched.technologyId}
                        required={
                          validation.values.hrCheck === false &&
                          validation.values.bdeCheck === false
                        }
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3">
                      <Label htmlFor="teammembersName" className="form-label">
                        {EmployeeLabels.DateOfJoining}
                        <span className="text-danger">{RequiredSign}</span>
                      </Label>
                      <Flatpickr
                        className={`form-control ${
                          validation.errors.dateOfJoin && "is-invalid"
                        }`}
                        id="datepicker-publish-input"
                        placeholder="Select a date"
                        name="dateOfJoin"
                        validate={{ required: { value: true } }}
                        onBlur={validation.handleBlur}
                        value={validation.values.dateOfJoin}
                        invalid={
                          !!(
                            validation.touched.dateOfJoin &&
                            validation.errors.dateOfJoin
                          )
                        }
                        options={{
                          altInput: true,
                          altFormat: "F j, Y",
                          dateFormat: "Y-m-d",
                          onChange: function (selectedDates, dateStr) {
                            validation
                              .setFieldValue("dateOfJoin", dateStr)
                              .then((res) => res)
                              .catch((err) => err);
                          },
                        }}
                      />
                      <div className="invalid-feedback">
                        {validation.errors.dateOfJoin}
                      </div>
                    </div>
                  </Col>
                  {userRoleCookie === Roles.Admin && !isEdit && (
                    <Col lg={6}>
                      <div className="mb-3">
                        <div className="d-flex">
                          <Input
                            type="checkbox"
                            id="teammembersName"
                            name="hrCheck"
                            onChange={handleHrCheckChange}
                            checked={validation.values.hrCheck}
                          />
                          <Label
                            htmlFor="teammembersName"
                            className="form-label"
                            style={{ paddingLeft: 10, paddingTop: 3 }}
                          >
                            {Roles.HR}
                          </Label>
                        </div>
                        <span>{EmployeeLabels.HRNote}</span>
                      </div>
                    </Col>
                  )}
                  {!isEdit && (
                    <Col lg={6}>
                      <div className="mb-3">
                        <div className="d-flex">
                          <Input
                            type="checkbox"
                            id="teammembersName"
                            name="bdeCheck"
                            onChange={handleBdeCheckChange}
                            checked={validation.values.bdeCheck}
                          />
                          <Label
                            htmlFor="teammembersName"
                            className="form-label"
                            style={{ paddingLeft: 10, paddingTop: 3 }}
                          >
                            {Roles.BDE}
                          </Label>
                        </div>
                        <span>{EmployeeLabels.BDENote}</span>
                      </div>
                    </Col>
                  )}
                </Row>
              </Col>
            </Row>
          </Form>
        </BaseModal>

        <BaseModal
          open={modalCourse}
          toggle={toggleCourse}
          title="Assign Course"
          closeLabel="Close"
          submitLabel="Submit"
          closeLabelColor="ghost-success"
          submitLabelColor="primary"
          submit={onsubmitCourse}
          loader={modalLoader}
        >
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              onsubmitCourse(e);
            }}
          >
            <Row>
              <Col lg={12}>
                <Row>
                  <Col lg={6}>
                    <div className="mb-3">
                      <BaseInput
                        name="firstName"
                        type="text"
                        placeholder={InputPlaceHolder(EmployeeLabels.FirstName)}
                        label={EmployeeLabels.FirstName}
                        value={assignCourseData.firstName}
                        disabled
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3">
                      <BaseInput
                        name="lastName"
                        type="text"
                        placeholder={InputPlaceHolder(EmployeeLabels.LastName)}
                        label={EmployeeLabels.LastName}
                        value={assignCourseData.lastName}
                        disabled
                      />
                    </div>
                  </Col>
                  <Col lg={12} md={6}>
                    <div className="mb-3">
                      <BaseInput
                        name="email"
                        type="email"
                        placeholder={InputPlaceHolder(
                          EmployeeLabels.OfficialEmailId
                        )}
                        label={EmployeeLabels.OfficialEmailId}
                        value={assignCourseData.email}
                        disabled
                      />
                    </div>
                  </Col>
                  <Col lg={12} md={6}>
                    <div className="mb-3">
                      <MultiSelect
                        value={selectedMulti}
                        isMulti
                        onChange={handleMulti}
                        options={topic}
                        label={EmployeeLabels.ITPCourse}
                      />
                    </div>
                  </Col>
                  <Col lg={12} md={6}>
                    <div className="mb-3">
                      <MultiSelect
                        value={selectedMultiProject}
                        isMulti
                        label={EmployeeLabels.ITPProject}
                        onChange={handleMultiProject}
                        options={itpProject}
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3">
                      <BaseSelect
                        name="technologyId"
                        options={designation}
                        placeholder={SelectPlaceHolder(EmployeeLabels.Role)}
                        label={EmployeeLabels.Role}
                        value={assignCourseData?.technologyId}
                        required
                        isDisabled
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3">
                      <Label className="form-label">
                        {EmployeeLabels.DateOfJoining}
                      </Label>
                      <Flatpickr
                        disabled
                        className="form-control"
                        name="dateOfJoin"
                        value={assignCourseData?.dateOfJoin}
                        options={{
                          altInput: true,
                          altFormat: "F j, Y",
                          dateFormat: "Y-m-d",
                        }}
                      />
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        </BaseModal>

        <BaseModal
          open={modalLeave}
          toggle={() => setModalLeave(false)}
          title={EmployeeLabels.EmployeeLeave}
          closeLabel={CommonLabel.Close}
          closeLabelColor="ghost-success"
        >
          <div className="relative-container">
            {modalLoader && <Loader />}
            <div className="grid grid-cols-3 gap-4">
              <InfoRow
                label={EmployeeLabels.CasualLeave}
                value={employeeLeave?.cl_count}
                iconClass="ri-calendar-line"
              />
              <InfoRow
                label={EmployeeLabels.CompOffLeave}
                value={employeeLeave?.col_count}
                iconClass="ri-time-line"
              />
              <InfoRow
                label={EmployeeLabels.LeaveWithoutPay}
                value={employeeLeave?.lwp_count}
                iconClass="ri-error-warning-line"
              />
            </div>
          </div>
        </BaseModal>

        <BaseModal
          open={modalReallocation}
          toggle={() => setModalReallocation(false)}
          title="Reallocation"
          closeLabel="Close"
          submitLabel="Reallocate"
          closeLabelColor="ghost-success"
          submitLabelColor="primary"
          submit={handleReallocationClick}
          loader={modalLoader}
        >
          <Col lg={12}>
            <div className="mb-3">
              <BaseSelect
                name="technologyId"
                options={employeeOption}
                placeholder={SelectPlaceHolder(EmployeeLabels.Senior)}
                value={selectedCourse}
                label={EmployeeLabels.Senior}
                handleChange={(field, value) => {
                  setSelectedCourse(value);
                }}
              />
            </div>
          </Col>

          <Col lg={12}>
            <div className="mb-3">
              <BaseSelect
                name="technologyId"
                options={employeeOption}
                placeholder={SelectPlaceHolder(EmployeeLabels.Junior)}
                value={selectedCourse2}
                label={EmployeeLabels.Junior}
                handleChange={(field, value) => {
                  setSelectedCourse2(value);
                }}
              />
            </div>
          </Col>
        </BaseModal>
      </div>
    </React.Fragment>
  );
};
export default Employee;
